// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-cell-NFNZf {
  font-size: 15px;
}

.cell-medium-UJAti {
  font-weight: 500;
}

.cell-bold-DSEsa {
  font-weight: bold;
}

.cell-black-QUjfl {
  color: var(--color-black);
}

.cell-gray-eUKOa {
  color: var(--color-neutral-600);
}

.cell-darkgray-OAQEC {
  color: var(--color-neutral-700);
}

.cell-blue-l2_td {
  color: var(--color-sky-700);
}

.cell-green-jSUAN {
  color: var(--money-color);
}

.cell-yellow-spf65 {
  color: var(--color-orange-700);
}

.cell-red-FIFAY {
  color: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/cell/cell.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".cell {\n  font-size: 15px;\n}\n\n.medium {\n  font-weight: 500;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.black {\n  color: var(--color-black);\n}\n\n.gray {\n  color: var(--color-neutral-600);\n}\n\n.darkgray {\n  color: var(--color-neutral-700);\n}\n\n.blue {\n  color: var(--color-sky-700);\n}\n\n.green {\n  color: var(--money-color);\n}\n\n.yellow {\n  color: var(--color-orange-700);\n}\n\n.red {\n  color: var(--accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `cell-cell-NFNZf`,
	"medium": `cell-medium-UJAti`,
	"bold": `cell-bold-DSEsa`,
	"black": `cell-black-QUjfl`,
	"gray": `cell-gray-eUKOa`,
	"darkgray": `cell-darkgray-OAQEC`,
	"blue": `cell-blue-l2_td`,
	"green": `cell-green-jSUAN`,
	"yellow": `cell-yellow-spf65`,
	"red": `cell-red-FIFAY`
};
export default ___CSS_LOADER_EXPORT___;
